/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/17/20
 * Time: 7:53 PM
 */
import React, {Component} from 'react';
import './ViewClass.scss';
import {Button, Row,Col} from "reactstrap";
import * as constants from "../../const/constants";
import {withRouter} from "react-router";
import * as actionCreator from "../../store/domain/classes/action";
import {connect} from "react-redux";
import * as commonFunc from "../../utils/commonFunc";
import moment from "moment";
import * as actionSpinnerCreator from "../../store/domain/spinner/action";
import {lang, language} from "../../const/language";
import swal from "sweetalert";

class App extends Component {



    purchaseHandler = () => {
        commonFunc.studentPurchaseWarning(this.props);
    };
    joinClassHandler = (object) => {
        commonFunc.joinClassHandler(this.props, object)
    };
    viewClassHandler = (object) => {
        this.props.history.push({
            pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_CLASS_ROUTE}`,
            state: `${object.id}`
        })
    };






    viewClassLessons = (object) => {
        commonFunc.viewClassResources(this.props,object.id);
    };
    viewClassPapers = (object) => {
        commonFunc.viewPaperResources(this.props,object.id,true);
    }

    render() {
        let {index, imageUrl, name, subject, dayTimes, nextDayOfClass,buttonStatus,fee,teacher,enrolledMonths,obj} = this.props;
        let title = `${name} - ${subject}`;

        return (
            <Row key={index} className={`view-class row shadow ${buttonStatus !== constants.BOUGHT_TEXT ? `expire-card`:`un-expire-card`}`}>
                <Col md={12} lg={3}>
                    <div className={"vc-image-wrapper"} onClick={()=>this.viewClassHandler(obj)}>
                        <img className={"vc-blur-image"} src={imageUrl} alt={"class"}/>
                        <img className={"vc-image"} src={imageUrl} alt={"class"}/>
                    </div>
                </Col>
                <p className={'vc-note'}>{`${teacher.teacherName}`}</p>
                <Col md={12} lg={6}>
                    <div className={"vc-right"}>
                        <p className={"vc-topic"}>{`${title.length > 50 ? title.substr(0,50)+'...':title}`}</p>
                        {
                            (nextDayOfClass !== undefined && nextDayOfClass !== null) &&
                            <p className={"vc-next"}>{`${language[lang].NextClassIsOn} ${moment(nextDayOfClass.replace("Z","")).format("DD MMM YYYY")} at ${moment(nextDayOfClass.replace("Z","")).format("h:mm A")}`}</p>
                        }

                        {
                            dayTimes !== 0 && dayTimes.map((dayTime, i) => (
                                <p className={"vc-day"}
                                   key={i}>{`${language[lang][dayTime.day]}, ${moment(`2000-01-01 ${dayTime.startTime}`).format('h:mm A')} to ${moment(`2000-01-01 ${dayTime.endTime}`).format('h:mm A')}`}</p>
                            ))
                        }

                        {
                            enrolledMonths.length !== 0 ? <div className={"enrolled-months"}>
                                    <p className={"title"}>{language[lang].PurchaseMonths}</p>
                                    {enrolledMonths.map((month, index) => (
                                        <li key={index}
                                            className={"text syllabus"}>{`${month.year} - ${language[lang][month.month]}`}</li>
                                    ))}
                                </div> :
                                <div className={"enrolled-months"}>
                                    <p className={"title mt-2 mb-2"}>{language[lang].FreeCard}</p>
                                </div>
                        }

                        {
                            ((nextDayOfClass !== undefined && nextDayOfClass !== null) && buttonStatus !== constants.BOUGHT_TEXT) &&
                            <Button className="btn-neutral normal-txt vc-mb-1" color="default"
                                    onClick={this.purchaseHandler}>
                                {`Purchase for ${moment(nextDayOfClass.replace("Z","")).format("MMM")} - LKR ${parseFloat(fee).toFixed(2)}`}
                            </Button>
                        }
                    </div>
                </Col>

                <Col md={12} lg={3} className="pb-3">
                    <div className={"vc-action mt-3"}>
                        <Button className="com-btn log-btn normal-txt mb-1" color="default" onClick={()=>this.viewClassHandler(obj)} >
                            {language[lang].ViewClassText}
                        </Button>

                        {
                            (teacher.privileges.split(':')[0] === '1' && buttonStatus === constants.BOUGHT_TEXT) &&
                            <Button className="com-btn log-btn normal-txt mb-1" color="default" onClick={()=>this.joinClassHandler(obj)} >
                                {language[lang].JoinTheClass}
                            </Button>
                        }
                        {
                            teacher.privileges.split(':')[1] === '1' &&
                            <Button className="com-btn log-btn normal-txt mb-1" color="default" onClick={()=>this.viewClassLessons(obj)} >
                                {language[lang].ClassResources}
                            </Button>
                        }
                        {
                            teacher.privileges.split(':')[3] === '1' &&
                            <Button className="com-btn log-btn normal-txt" color="default" onClick={()=>this.viewClassPapers(obj)} >
                                {language[lang].QuizesAndTestPapers}
                            </Button>
                        }
                    </div>
                </Col>

            </Row>
        );
    }
}
const mapStateToProps = (state) => ({
    userType: state.auth.userType,
    selectClass: state.classes.selectClass,
});

const mapDispatchToProps = (dispatch) => ({
    selectClassHandler: data => dispatch(actionCreator.selectClass(data)),
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
});


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
